import { useMemo } from 'react'

import { useShallowEqualSelector } from './useShallowEqualSelector'

export const useIsMobileView = () => {
  const { mobile } = useShallowEqualSelector(({ systemView: { mobile } }) => ({
    mobile,
  }))
  return useMemo(() => mobile, [mobile])
}
